import { createSlice } from '@reduxjs/toolkit';

const initialState = { product: 'the-platinum-card' };

const lastViewedProductSlice = createSlice({
  name: 'lastViewedProduct',
  initialState,
  reducers: {
    setLastViewedProduct(state, action) {
      return {
        ...state,
        product: action.payload,
      };
    },
  },
});

export const { setLastViewedProduct } = lastViewedProductSlice.actions;

export default lastViewedProductSlice.reducer;
